<template>
  <div class="items_section" v-if="fairList.length">
    <div class="items_list" v-for="fair of fairList" :key="fair.id">
      <a :href="fair.url">
        <div class="item-media">
          <img :src="fair.thumbnail_url" alt="">
          <div class="add_zt">
            <img :src="fair.status === 9 ? require('../../assets/image/icon5.png'):require('../../assets/image/icon5_2.png')">
          </div>
        </div>
        <div class="item-inner">
          <!-- <span>{{fair.fair_name}}</span> -->
          <h6>{{fair.fair_name}}</h6>
          <p class="item-text">报名时间：{{fair.reserve_time}}-{{fair.end_reserve_time}}</p>
          <p class="item-text">会议时间：{{fair.start_time}}-{{fair.end_time}}</p>
          <p class="item-text">地址：{{fair.city}}</p>

        </div>
      </a>
    </div>
  </div>
</template>

<script type="text/babel">
  import axios from 'axios'

  export default {
    data() {
      return {
        params: this.$route.params,
        fairList: []
      }
    },
    methods: {
      getFairLIst() {
        axios
          .get('/fair/fair-list?page=1&pageSize=10')
          .then(this.getFairLIstSucc)
      },
      getFairLIstSucc(res) {
        res = res.data
        if (res.status && res.datalist) {
          this.fairList = res.datalist
        }
      }
    },
    mounted() {
      this.getFairLIst()
    }
  }
</script>

<style lang="stylus" scoped>
  .items_section
    background #fff
    padding 15px
    padding-bottom 0


  .items_list
    width 100%
    overflow hidden
    margin-bottom 0.45rem

  .items_list .item-media
    float left
    width 37%
    position relative

  .items_list .item-media img
    width 100%
    height 2.38934rem

  .items_list .item-media .add_zt
    position absolute
    z-index 9
    right 0
    top 0

  .items_list .item-media .add_zt img
    width 0.84625rem
    height auto

  .items_list .item-inner
    float right
    width 59%

  .items_list .item-inner h6
    font-size 0.306725rem
    color #333
    font-weight normal
    margin 0
    margin-bottom 0.15rem
    display -webkit-box
    -webkit-box-orient vertical
    -webkit-line-clamp 2
    overflow hidden

  .items_list .item-inner p
    font-size 0.26725rem
    color #666
    margin-bottom 0.08725rem

</style>



// WEBPACK FOOTER //
// src/views/template1/FairList.vue